import React from 'react'
import MatrixValue from './MatrixValue'

import * as scoreService from '../services/score-service'

export default class ScoreMatrix extends React.Component {

  constructor(props, context) {
    super(props, context)

    this.createTable = this.createTable.bind(this)
    this.getScore = this.getScore.bind(this)

    this.state = {
      rows: []
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.matrix !== this.props.matrix) {
      scoreService.getSteeringWheels().then((wheels) => {
        scoreService.getQuestionPhases().then((phases) => {
          this.createTable(phases, wheels);
        })
      })
    }
  }

  createTable(phases, wheels) {
    let rows = []

    // header row
    let header = []
    phases.map((phase) => {
        return header.push(phase.name)
    })
    header.push('')
    rows.push(header)

    // detail rows
    wheels.map((wheel) => {
      let row = []
      phases.map((phase) => {
        const score = this.getScore(wheel, phase)
        return row.push(score)
      })
      row.push(wheel.name)
      return rows.push(row)
    })

    this.setState({
      rows: rows
    })
  }

  getScore(wheel, phase) {
    let matrix = this.props.matrix

    let result = matrix.filter(function(score) {
      return score.steeringWheel === wheel.name && score.phase === phase.name
    })
    return (result && result.length === 1) ? result[0].score : null
  }

  render() {
    const {rows} = this.state

    return (
      <div className="result-matrix">
        <table>
          <tbody>
            { rows.map((row, i) => <tr key={i}>{row.map((column, c) => <td key={i + ' ' + c}><MatrixValue score={column}/></td>)}</tr>) }
          </tbody>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ScoreMatrix.js